// extracted by mini-css-extract-plugin
export default {"animation":"FrostAnimation_animation","disableAnimation":"FrostAnimation_disableAnimation","withoutTransition":"FrostAnimation_withoutTransition"};